import type { OrderTab, OrderTabState } from './OrderTabs.types'

export const getOrderTabTestId = (dateTitle: string) =>
  dateTitle
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')

const toOrderTabState = ({ default_active, ...tab }: OrderTab): OrderTabState => ({
  ...tab,
  isActive: default_active,
})

export const getInitialTabs = (tabs: OrderTab[]): OrderTabState[] => tabs.map(toOrderTabState)

export const setActiveTab = (tabs: OrderTabState[], activeIndex: number): OrderTabState[] =>
  tabs.map((tab, index) => ({
    ...tab,
    isActive: index === activeIndex,
  }))
